/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectTaskCommand } from '../../models/update-project-task-command';
import { UpdateProjectTaskCommandResult } from '../../models/update-project-task-command-result';

export interface ApiProjectTaskUpdateProjectTaskPost$Params {
      body?: UpdateProjectTaskCommand
}

export function apiProjectTaskUpdateProjectTaskPost(http: HttpClient, rootUrl: string, params?: ApiProjectTaskUpdateProjectTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTaskUpdateProjectTaskPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectTaskCommandResult>;
    })
  );
}

apiProjectTaskUpdateProjectTaskPost.PATH = '/api/ProjectTask/UpdateProjectTask';
